import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyALXPNJuJlX-hMkwT015yuPXjNxDC93mxs",
  authDomain: "jhdfsdsgjkgfgf.firebaseapp.com",
  projectId: "jhdfsdsgjkgfgf",
  storageBucket: "jhdfsdsgjkgfgf.appspot.com",
  messagingSenderId: "1077834271502",
  appId: "1:1077834271502:web:4bbacddef157e6bdb5e55f"
};

  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  export default firebase

